<template>
  <!-- ダウンロード -->
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <div class="message"
        :style="{
        'background' : speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
        'color'      : autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
        'filter'     : shadowStyle(color.shadowType)}">
      <p class="message-title">{{pdfDownloadCreate(message)}}</p>
      <div class="field" v-if="!isNowButton()">
        <button class="button message-button is-small" @click="isDownloadClick(); pdfDownload()">{{messageEscape(parameter['file_name'])}}</button>
      </div>
      <hr v-if="!isNowButton()">
      <div class="field" v-if="!isNowButton()">
        <button class="button message-button is-small" @click="afterDownload(0)" :disabled="!isDownloaded">ダウンロード完了</button>
      </div>
    </div>
  </div>
</template>

<script>
import hex2rgb from '@/functions/hex2rgb'
// 外部関数
import {
  autoColor,
  shadowStyle,
  isNowButton,
  messageEscape,
  pdfDownloadCreate,
  isDownloadClick,
} from '@/functions/balloonFunc'

export default {
  name: 'PdfDownloadParts',
  props: ['message', 'speaker', 'color', 'parameter', 'lastIndex', 'logIndex', 'isBot', 'isDemo', 'roboArguments'],
  mount () {
    this.parameter['file_name'] = this.messageEscape(this.parameter['file_name'])
  },
  data () {
    return {
      isDownloaded: false,
    }
  },
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    messageEscape (m) {
      return messageEscape(m, this.roboArguments)
    },
    pdfDownloadCreate (m) {
      return pdfDownloadCreate(m, this.roboArguments)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    pdfDownload () {
      this.$emit('pdfDownload')
    },
    afterDownload (btnIndex) {
      this.$emit('afterDownload', btnIndex)
    },
    // ダウンロードボタン活性化用のメソッド
    isDownloadClick() {
      // balloonFuncからインポートしたisDownloadClick関数を呼び出して、返り値をisDownloadedに反映する
      this.isDownloaded = isDownloadClick(this.isDownloaded)
    },
  },
}
</script>

<style lang="scss" scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  font-size: medium;
  border-radius: 8px;
  transition: 0.7s;
}
.message > .message-title {
  text-align: left;
  filter: none;
  font-size: smaller;
  word-wrap: break-word;
  margin-bottom: 8px;
  white-space: pre-wrap;
}
.message > .message-button {
  display: flex; 
  justify-content: left;
  filter: none;
  min-width: 100%; max-width: 100%;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 10px;
  height: auto;
  overflow: initial;
  white-space: normal;
  text-overflow: ellipsis;
  font-size: smaller;
  text-align: left;
  border-radius: 8px;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
.message-button {
  border: none;
  border-radius: 8px;
}
/* Animation */
@for $i from 0 through 6 {
  $enter-delay: 300ms;
  &.slide-button-#{$i} {
    // opacity: 1;
    animation-duration: #{200ms * ($i + 1)};
    animation-name: slide-in;
  }
}
@keyframes slide-in {
  0% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  70% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  100% {
    // opacity: 1;
    transform: scale(1) translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/PdfDownloadParts.vue